
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDirection } from '@/providers/DirectionProvider';

interface SearchHeaderProps {
  displayProfessionName?: string;
}

const SearchHeader: React.FC<SearchHeaderProps> = ({ displayProfessionName }) => {
  const { t } = useTranslation();
  const { direction } = useDirection();

  return (
    <div className="text-center mb-10">
      <h1 className="text-3xl md:text-4xl font-bold text-blue-700 mb-3">
        {t('search.searchTitle')} <span className="text-teal-500">{t('search.professionalsTitle')}</span>
        {displayProfessionName && <span className="text-blue-700"> - {displayProfessionName}</span>}
      </h1>
      <p className="text-gray-600 max-w-2xl mx-auto">
        {t('search.headerSubtitle')}
      </p>
    </div>
  );
};

export default SearchHeader;
